import { BaseeSearchClass,ReturnClass } from "projects/Shared-Lib/model/search-result";
import { SelectListItem } from '../lib/select/select-property';
import * as t from '../lib/select/select-service';
import { DialogService } from "projects/Shared-Lib/component/dialog/dialog.service";
import { Router } from "@angular/router";
import { DataService } from "projects/Shared-Lib/services/data.service";

const ControllerName: string = 'AuthApplication';

export class SearchClass extends BaseeSearchClass {
  ApplicationID?: string;
  IsEnabled?: string;
}

export class AuthApplication {
  ApplicationID?: string;
  AuthCode?: string;
  IP?: string;
  GrantType?: string;
  ReturnUrl?: string;
  ErrorReturnUrl?: string;
  IsEnabled?: boolean;
  IsDeleted?: boolean;
  TokenAPI?: string;
  PermissionAPI?: string;
  CreatedDateTime?: string;
  CreatedBy?: string;
  UpdatedDateTime?: string;
  UpdatedBy?: string;
  SelectEnabled?: any;

  constructor() {
    // Initialize properties if needed
  }

  SetData(data: AuthApplication) {
    this.ApplicationID = data.ApplicationID;
    this.AuthCode = data.AuthCode;
    this.IP = data.IP == null ? '' : data.IP;
    this.GrantType = data.GrantType;
    this.ReturnUrl = data.ReturnUrl == null ? '' : data.ReturnUrl;
    this.ErrorReturnUrl = data.ErrorReturnUrl == null ? '' : data.ErrorReturnUrl;
    this.IsEnabled = data.IsEnabled;
    this.IsDeleted = data.IsDeleted;
    this.TokenAPI = data.TokenAPI;
    this.PermissionAPI = data.PermissionAPI;
    this.SelectEnabled = data.IsEnabled ? 1 : 0;
  }
}

export class AuthApplication_Search {
    filter: SearchClass;
    ddlIsEnabled?: SelectListItem[];
    selectedEnabled?: SelectListItem;
    DataResult?: ReturnClass;

    constructor() {
        this.filter = new SearchClass();
        this.filter.ApplicationID = '';
        this.filter.IsEnabled = '';

        this.ddlIsEnabled = t.GetItems(t.Items.Options_Enabled, true);
        this.DataResult = { draw: 1, recordsFiltered: 0, recordsTotal: 0, data: [] };
    }
}

export class AuthApplication_Document extends AuthApplication {
    ddlIsEnabled?: any;
    SelectEnabled?: any;
    ddlGrantType?: SelectListItem[];

    constructor(private _dlgService: DialogService, private router: Router, private dataService: DataService) {
        super();
        this.ddlIsEnabled = t.GetItems(t.Items.Options_Enabled);
        this.ddlGrantType = [{ value: "client", text: "client"},
                             { value: "confidential", text: "confidential"},
                             { value: "public", text: "public"}];
    }

  /** Get Document by ApplicationID
  * @param uid : string
  */
  GetDocument(uid: string) {
    this.dataService.getData(`${ControllerName}/${uid}`, null, (ret) => {
      this.SetData(ret);
    }, (ret) =>{
      this._dlgService.ErrorInformation(ret.Message);
    });
  }
}
